/**
 * A glossary.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readArray, readString } from '@/domain/json'
import type { JsonValue } from '@/domain/json'
import { newGlossaryEntry, newId, type GlossaryEntry, type GlossarySection } from '@/domain/section'
import GlossaryBlock from '@/sections/glossary/GlossaryBlock.vue'
import GlossaryInspector from '@/sections/glossary/GlossaryInspector.vue'
import type { SectionDefinition } from '@/sections/types'

function readGlossaryEntry(value: JsonValue): GlossaryEntry {
  return {
    id: readString(value, 'id') || newId(),
    term: readString(value, 'term'),
    definition: readString(value, 'definition'),
  }
}

export const glossarySection: SectionDefinition<'glossary', GlossarySection> = {
  kind: 'glossary',
  band: 'annex',

  icon: ['M3 4h4.5', 'M5 6.5h8', 'M3 9.5h4.5', 'M5 12h8'],

  create: (id, title) => ({
    id,
    kind: 'glossary',
    title,
    entries: [newGlossaryEntry()],
  }),

  read: ({ id, title, stored }) => ({
    id,
    kind: 'glossary',
    title,
    entries: readArray(stored, 'entries').map(readGlossaryEntry),
  }),

  block: GlossaryBlock,
  inspector: GlossaryInspector,
}
